<div
  class="container max-width"
  [class.wide]="data?.options?.fullWidth">
  @if (data?.content?.sections?.length) {
    <div
      class="sections"
      [class.one-section]="data?.content?.sections?.length === 1"
      [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }">
      @for (section of data.content.sections; track section) {
        <div>
          <p
            [class.bold]="data?.options?.isBold"
            [innerHTML]="section.text"></p>
          @if (section.oList?.length) {
            <ol>
              @for (oListItem of section.oList; track oListItem) {
                <div>
                  <li class="p bold">
                    <p [innerHTML]="oListItem?.text"></p>
                  </li>
                  @if (oListItem?.uList?.length) {
                    <div>
                      <ul>
                        @for (uListText of oListItem.uList; track uListText) {
                          <li class="p">
                            <p [innerHTML]="uListText"></p>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  @if (oListItem?.additionalText) {
                    <p
                      class="space"
                      [innerHTML]="oListItem.additionalText"></p>
                  }
                </div>
              }
            </ol>
          }
          @if (section.uList?.length) {
            <ul>
              @for (uListText of section.uList; track uListText) {
                <li class="p">
                  <p [innerHTML]="uListText"></p>
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  }
  @if (data?.content?.buttons?.length) {
    <div class="buttons">
      @for (button of data.content.buttons; track button) {
        <coin-v2-button
          icon="chevron_right"
          iconPos="right"
          [type]="button.url ? 'primary' : 'secondary'"
          [text]="button.name"
          (click)="onButtonClick(button)"></coin-v2-button>
      }
    </div>
  }
</div>
